import script from "./UserInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserInfo.vue?vue&type=script&setup=true&lang=ts"

import "./UserInfo.vue?vue&type=style&index=0&id=79955740&scoped=true&lang=less"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79955740"]])

export default __exports__